



/* eslint-disable linebreak-style */
// eslint-disable-next-line linebreak-style
/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from 'react';
import Tour from 'reactour';

import PremiumPlanImage from './../../assets/images/plan_premium.svg';
import { connect } from 'react-redux';
import { Typography, Button, withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';

import { fetchDepartments } from '../../store/actions/department';
import { verifyChat } from '../../store/actions/chat';
import LastDaysModal from '../../components/LastDaysModalContent/LastDaysModal';

import { styles } from './styles';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import Input from '../../components/Input/Input';
import tourConfig from './tourConfig';

import PresenceChart from './charts/PresenceChart';
import EventChart from './charts/EventChart';
import PremiumCard from './charts/PremiumCard';
import LeaveChart from './charts/LeaveChart';
import WorkActivityChartAll from './charts/WorkActivityChartAll';
import PhotoChart from './charts/PhotoChart';
import Map from './Map';
import axios from '../../config/axiosInstance';
import Temperature from './temperatureComponent/temperature';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CardMedia from '@material-ui/core/CardMedia';
import Card from "@material-ui/core/Card";
import { Link } from 'react-router-dom';
import StarIcon from '@material-ui/icons/Star';
import { usageLog } from '../../store/actions/globalActions';
import apertomão from '../../assets/images/apertomão.gif';
import conversa from '../../assets/images/conversa.gif';
import ideia from '../../assets/images/ideia.gif';
import redesocial from '../../assets/images/redesocial.gif';
import NewSubscription from '../Subscription/NewSubscription';
import CouponModal from '../../components/RestrictionModal/CouponModal';
import WarningModal from '../../components/RestrictionModal/WarningFree';
import WarningFimGratis from '../../components/Dashboard/Warnings/WarningFimGratis';
import AvisoPuntu from '../../components/RestrictionModal/AvisoFimGratis';

class BI2 extends React.Component {
  state = {
    department: this.props.departments[0].value,
    isTourOpen: false,
    presenceData: null,
    leaveData: null,
    photoData: null,
    mapData: null,
    premium: false,
    modal: false,
    modal2: false,
    modalAvisoInadimplentes: false,
    disabledButton: false,
    daysCompany: null,
    seconds: 15,
    socialName: '',
    email: '',
    district: '',
    address: '',
    city: '',
    cityCod: '',
    uf: '',
    cep: '',
    formularioBoleto: false,
    showModal: false
  };

  componentDidMount() {
    // this.searchStatusPayment();
    this.callTheOthers();
    this.VerifyModalLaCasaSinPapel();
    this.handleCloseModalLaCasa()
  }

  // searchStatusPayment() {
  //   localStorage.removeItem("statusPayment");
  //   axios.get('/company/statusPayment')
  //     .then((result) => {
  //       localStorage.setItem("statusPayment", result.data.hasAccess);
  //       if (result.data.hasAccess) {
  //         this.callTheOthers();
  //       }
  //     })
  //     .catch(error => console.log('error', error));
  // };

  callTheOthers() {
    // axios.get('/automatic/events/removeEmployeesInactives');
    this.props.onFetchDepartments();
    this.isPremium();
    this.fetchData();
    // this.fetchEvent();
    // this.fetchChat();
    this.fetchWorkActivity();
    this.companyData();
    this.fetchPresenceToday();
    this.fetchEventCount();
  }

  isPremium = () => {
    const validaetPremium = JSON.parse(localStorage.getItem('privileges')).isExportAfd;
    if (validaetPremium === false) {
      this.setState({ premium: false });
    } else {
      this.setState({ premium: true });
    }
  }

  fetchChat = async () => {
    const response = await axios.get('/jivoChat/suportPlanUrl');
    verifyChat(response.data, this.props.companyCode, this.props.businessName, this.props.userName);
  }

  handleDepartment = (event) => {
    this.setState({ department: event.target.value });
  };

  fetchEvent = () => {
    axios.get('/event/pending')
      .then((result) => {
        this.setState({
          //Estamos filtrando os dados, enquanto os eventos do tipo 3 e 4 nao entram em producao
          eventData: result.data.filter((value) => { return value.typeEventId <= 4 }),
        });
      })
      .catch(error => console.log('error', error));
  }

  fetchEventCount = () => {
    axios.get('/event/eventDivergences')
      .then((result) => {
        this.setState({
          //Estamos filtrando os dados, enquanto os eventos do tipo 3 e 4 nao entram em producao
          eventDataCount: result.data,
        });
      })
      .catch(error => console.log('error', error));
  }

  fetchWorkActivity = () => {
    axios.get('workActivity/allActivities')
      .then((result) => {
        // console.log('fetchWorkActivity', result)
        this.setState({
          workActivity: result.data.slice(0, -1),
        });
      })
      .catch(error => console.log('error', error));
  }

  companyData = () => {
    axios.get('/companyData')
      .then((result) => {
        // console.log('fetchWorkActivity', result)
        this.setState({
          socialName: result.data.socialName,
          email: result.data.email,
          district: result.data.district,
          address: result.data.address,
          city: result.data.city,
          cityCod: result.data.cityCod,
          uf: result.data.uf,
          cep: result.data.cep
        });
      })
      .catch(error => console.log('error', error));
  };

  fetchData = () => {
    axios.get('/timeclocks/timeclocksToday')
      .then((result) => {
        this.setState({
          mapData: result.data,
        });
      })
      .catch(error => console.log('error', error));
  }

  fetchPresenceToday = () => {
    axios.get('/company/presenceToday')
      .then((result) => {
        this.setState({ presenceData: result.data })
      })
      .catch(error => console.log('error', error));
  }

  verifyGestororAdmin = () => {
    const isAdmin = JSON.parse(localStorage.getItem('isAdmin'));
    if (isAdmin === false) {
      this.setState({ openGestor: true, openAgreement: false });
    }
    if (isAdmin === true) {
      this.setState({ openGestor: false, openAgreement: true });
    }
  }


  VerifyModalLaCasaSinPapel = () => {
    try {
      const lastModalShownDate = localStorage.getItem('modalShownDate');
      const today = new Date();

      if (!lastModalShownDate) {
        // Se o modal nunca foi mostrado, exiba o modal
        this.setState({ showModal: true });
        // Atualize o localStorage para indicar que o modal foi exibido hoje
        localStorage.setItem('modalShownDate', today.toISOString());
      } else {
        const lastDate = new Date(lastModalShownDate);
        const isSameDay = lastDate.getDate() === today.getDate() && lastDate.getMonth() === today.getMonth() && lastDate.getFullYear() === today.getFullYear();

        if (!isSameDay) {
          // Se o modal não foi exibido hoje, exiba o modal
          this.setState({ showModal: true });
          // Atualize o localStorage para indicar que o modal foi exibido hoje
          localStorage.setItem('modalShownDate', today.toISOString());
        }
      }
    } catch (error) {
      console.log(error)
    }
  }





  handleCloseModalVerify = () => {
    const companyId = JSON.parse(localStorage.companies)
    this.setState({ showModal: false })
    usageLog("laCasaSinPapel/modal/aviso/pagina_Indique", companyId[0].companyId, companyId[0].byUser)
  }

  handleCloseModalLaCasa = () => {
    const targetDate = new Date(2023, 11, 22, 23, 59, 0);
    if (new Date() > targetDate) {
      this.setState({ showModal: false })
    }
  }


  confirmTerm = async () => {
    const token = localStorage.getItem('token');
    await axios.post('/terms', {
      headers: { Authorization: `Bearer ${token}` },
    }).catch(() => {
    });
  }

  onClickSlice = (sliceInfo) => {
    let newValue = null;
    if (sliceInfo.id !== this.state.selectedSlice) {
      newValue = sliceInfo.id;
    }
  }


  render() {
    const {
      classes,
      userName,
      departments,
    } = this.props;

    const {
      department, isTourOpen, openAgreement, openGestor,
    } = this.state;


    return (
      <div>
        <ContentHeader title={`Bem-vindo, ${userName}`} subtitle="Resumo por departamentos " >
          <div className={classes.input} style={{ display: 'flex', alignItems: 'center' }}>

            {/* <LastDaysModal openAgreement={openAgreement} openGestor={openGestor} /> */}

            <Typography variant="subheading" color="primary" className={classes.sliderText}>
              Visão Geral por Departamentos:
            </Typography>
            <Input
              data-tut="reactour__departamento"
              style={{ width: '250px', margin: 0 }}
              elementType="select"
              value={department || ''}
              onChange={this.handleDepartment}
              type="text"
              margin="normal"
              required
              options={departments}
            />
          </div>
          <Button color="primary" onClick={() => this.setState({ isTourOpen: true })} >Está com Duvidas?</Button>
        </ContentHeader>

        <Tour
          onRequestClose={() => this.setState({ isTourOpen: false })}
          steps={tourConfig}
          isOpen={isTourOpen}
          maskClassName=""
          className="helper"
          rounded={5}
          accentColor="#537ccd"
        />

        {/* modal do primeiro aviso do fim do plano gratis  */}
        {/* <WarningFimGratis open={this.state.showModal} onClose={this.handleCloseModalVerify} handleCloseModalLaCasa={this.handleCloseModalLaCasa} /> */}

        {/* modal cupom  */}
        {/* <AvisoPuntu /> */}
        {/* <CouponModal /> */}

        <Grid container spacing={1} justify="center" data-tut="reactour__pontualidade" >

          {this.props.thermalPrivilege && <Temperature />}

          <Grid item md={6}>
            <PresenceChart
              data={this.state.presenceData}
              department={this.state.department}
              classes={classes}
            />
          </Grid>

          <Grid item md={6}>
            <EventChart
              data={this.state.eventDataCount}
              department={this.state.department}
              classes={classes}
            />
          </Grid>

          <Grid item md={6}>
            <WorkActivityChartAll
              data={this.state.workActivity}
              onClickSlice={this.onClickSlice}
              department={this.state.department}
              classes={classes}
            />
          </Grid>

          {/* <Grid item md={6}>
            {this.state.premium == true ?
              (
                <LeaveChart
                  data={this.state.leaveData}
                  department={this.state.department}
                  classes={classes}
                />
              ) :
              <PremiumCard
                img={PremiumPlanImage}
                classes={classes}
              />
            }
          </Grid> */}

          {/* <Grid item md={3}>
            <PhotoChart
              data={this.state.photoData}
              department={this.state.department}
              classes={classes}
            />
          </Grid> */}
        </Grid>


        <Map data={this.state.mapData} classes={classes} department={this.state.department} />
      </div >
    );
  }
}

const handleOptions = (departments) => {
  const newDepartments = [{ value: -1, displayValue: 'TODOS' }];
  departments.map(department =>
    newDepartments.push({
      value: department.id,
      displayValue: department.name,
    }));
  return newDepartments;
};

const mapStateToProps = state => ({
  userName: state.auth.userName,
  departments: handleOptions(state.department.departments),
  companyCode: state.auth.companyCode,
  businessName: state.auth.businessName,
  thermalPrivilege: state.auth.privileges && state.auth.privileges.thermal,
});

const mapDispatchToProps = dispatch => ({
  onFetchDepartments: () => dispatch(fetchDepartments()),
});


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(BI2));






